import { useEffect, useState } from "react";
import DashboardTwoCharts from "./chart";
import State from "./state";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

const HomeHero = () => {
  const [analytics, setAnalytics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) { setIsLoading(false); return; }
      try {
        const res = await fetch(`${BASE_URL}${API_ENDPOINTS.SUPERADMIN_DASHBOARD_ANALYTICS}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json();
        if (res.ok) setAnalytics(result?.data ?? result);
      } catch (err) {
        console.error("Failed to fetch dashboard analytics:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  return (
    <main className="w-[97%] mx-auto mt-5 pb-10">
      <State analytics={analytics} isLoading={isLoading} />
      <DashboardTwoCharts analytics={analytics} isLoading={isLoading} />
    </main>
  );
};

export default HomeHero;
